import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, defineMessages } from 'react-intl'
import { Button, WordboxStats, OptionsStats, TranslationStats } from '../components'
import { exerciseTypes } from '../../common/config'

const ResultsAggregatedStats = ({ stats, intl }) => (
  <div className="width-full float-left vertical-spacing aggregated-stats">
    <h3 className="vertical-spacing">{intl.formatMessage(messages.answersStats)}</h3>
    <div className="width-full float-left">
      {
        stats && stats.exercises && stats.exercises.map((e, exerciseId) => (
          e && e._id &&
          <div key={exerciseId}>
            {
              e.lesson.type === exerciseTypes.OPTIONS &&
              <OptionsStats
                lesson={e.lesson}
                exerciseStats={stats.exercises[exerciseId]}
              />
            }
            {
              e.lesson.type === exerciseTypes.WORDBOX &&
              <WordboxStats
                lesson={e.lesson}
                exerciseStats={stats.exercises[exerciseId]}
              />
            }
            {
              e.lesson.type === exerciseTypes.TRANSLATION &&
              <TranslationStats
                lesson={e.lesson}
                exerciseStats={stats.exercises[exerciseId]}
              />
            }
          </div>
        ))
      }
    </div>
  </div>
)

ResultsAggregatedStats.defaultProps = {
  stats: null,
  intl: null,
}

ResultsAggregatedStats.propTypes = {
  stats: PropTypes.object,
  intl: PropTypes.object,
}

export default injectIntl(ResultsAggregatedStats)

const messages = defineMessages({
  answersStats: {
    id: 'stats.answersStats',
    defaultMessage: 'Štatistiky odpovedí',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/ResultsAggregatedStats.js